/* istanbul ignore file */
import React from 'react';
import { SecurityContextTemplate, SecurityContextCommonProps } from 'framework/authorization';
import { useEmployeeService } from 'domain/shared/employee';

const ContractsContext = ({ permissionToCheck, children }: SecurityContextCommonProps) => {
  const { getGlobalPeopleManagementPermissions } = useEmployeeService();
  const CONTEXT_NAME = 'Contracts_CONTEXT';

  return (
    <SecurityContextTemplate
      getPermissionsFunc={getGlobalPeopleManagementPermissions}
      permissionToCheck={permissionToCheck}
      contextName={CONTEXT_NAME}
    >
      {children}
    </SecurityContextTemplate>
  );
};

export default ContractsContext;
